__turbopack_context__.v({
  "banner": "error-banner-module-scss-module__r7tisq__banner",
  "placeholder": "error-banner-module-scss-module__r7tisq__placeholder",
});
